import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft, Mail, Lock } from "lucide-react";
import { PasswordInput } from "./PasswordInput";

export function SetPasswordForm({
  email,
  password,
  setPassword,
  loading,
  onBack,
  onSubmit
}) {
  return (
    <div className="space-y-6">
      <button 
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
      >
        <ArrowLeft className="h-4 w-4 mr-2" /> Back
      </button>

      <div className="text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Lock className="h-8 w-8 text-blue-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900">Set Your Password</h2>
        <p className="text-gray-600 mt-2">First time login? Set a password for your account</p>
      </div>

      <div className="space-y-4">
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input
            type="email"
            value={email}
            disabled
            className="pl-10 bg-gray-50"
          />
        </div>
        
        <PasswordInput
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Create password (min 8 characters)"
        />
      </div>

      <Button 
        onClick={onSubmit}
        disabled={loading}
        className="w-full bg-blue-600 hover:bg-blue-700"
      >
        {loading ? "Setting..." : "Set Password"}
      </Button>
    </div>
  );
}
